export default __webpack_public_path__ + "static/2-76c078a7112ebeec50df20dcc25aef06.jpeg";